import { DefaultFilter } from '@molecules/Filters';
import { SelectChangeEvent } from '@mui/material';
import { FilterItem, OptionType } from '@services';
import { ReactNode } from 'react';
const key = 'label';

const createLabelFilter = ({ options }: { options: OptionType[] }): FilterItem => {
  return {
    name: 'Label',
    key,
    getFilter: (onChange, onClose, setFilters, filter): ReactNode => (
      <DefaultFilter
        key={key}
        name="Label"
        value={filter[key]}
        items={options}
        onChange={(event: SelectChangeEvent<unknown>) =>
          setFilters({ ...filter, [key]: event.target.value as string })
        }
        onClose={onClose}
      />
    ),
  };
};

export default createLabelFilter;
